export const ROUTES = {
  DASHBOARD: '/dashboard',
  EXPORT: '/export'
};
